/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description <p>Возможные значения:</p>\n<ul>\n<li><b>1 - Everyday</b>: Ежедневно</li>\n<li><b>2 - OnDate</b>: На дату</li>\n<li><b>3 - OnPeriod</b>: На период</li>\n</ul>\n
 */
export const greetingConditionTypeEnumSchema = z.union([z.literal(1), z.literal(2), z.literal(3)]).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Everyday</b>: Ежедневно</li>\n<li><b>2 - OnDate</b>: На дату</li>\n<li><b>3 - OnPeriod</b>: На период</li>\n</ul>\n")